import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Tabs, message, Spin } from 'antd';
import AuthorizeByRule from './routes/AuthorizeByRule';
import AuthorizeByGroup from './routes/AuthorizeByGroup';
import { callApi } from '../../utils/callApi/rest';
import { api } from './config';
import { getBasicInfo } from './utils';

import './index.less';

const { TabPane } = Tabs;
const prefixCls = 'right-management-main';
class RightManagement extends PureComponent {
	state = {
		labelGroupId: undefined, //标签组ID
		showFlag: 0, //是否展示按角色授权Tab页：0-不展示、1-展示
		currentKey: '1', //当前的tab
		allPrivileges: [], //全部的权限组
		allCommunities: [],
		loading: false,
	};

	componentWillMount() {
		sessionStorage.removeItem('selectedConfig'); // 清除商机审批设置缓存
	}

	componentDidMount() {
		this.getRoleAuthConfig();
		this.listServiceModulePrivileges();
		this.listAllCommunities();
	}

	getRoleAuthConfig = () => {
		const data = getBasicInfo();
		this.setState({ loading: true }, () => {
			callApi({
				api: '/OAAuthorization/getRoleAuthConfig',
				data,
				success: (res) => {
					this.setState({
						showFlag: res.showFlag,
						labelGroupId: res.labelGroupId,
						loading: false,
					});
				},
			});
		});
	};

	// 获取所有权限名称
	listServiceModulePrivileges = () => {
		const { namespaceId, moduleId, organizationId } = window.$$context;
		const param = { moduleId, organizationId, namespaceId };
		return callApi({
			api: api.getOperations,
			data: param,
			defaultError: false,
		}).then((response) => {
			this.setState({
				allPrivileges: response.filter((t) => t.operations && t.operations.length > 0),
			});
		});
		// 	.catch(err => {
		// 	message.error(`请求出错 ${err && err.errorDescription ? err.errorDescription : ''}`);
		// });
	};

	/**
	 * 获取所有项目
	 */
	listAllCommunities() {
		const { namespaceId, organizationId, appId } = window.$$context;
		return callApi({
			api: api.getAuthorizedCommunities,
			data: {
				namespaceId,
				orgId: organizationId,
				appId,
				filterByAuthorization: 0,
			},
			success: (res) => {
				this.setState({ allCommunities: res.authorizedCommunities });
			},
		});
	}

	onChange = (e) => {
		this.setState({ currentKey: e });
	};

	render() {
		const { loading, labelGroupId, showFlag, currentKey, allPrivileges, allCommunities } = this.state;
		return (
			<React.Fragment>
				{loading ? (
					<div className={prefixCls + '-spin'}>
						<Spin spinning={true} />
					</div>
				) : (
					<Tabs defaultActiveKey="1" activeKey={currentKey} type="card" onChange={this.onChange}>
						<TabPane tab="按规则授权" key="1">
							<AuthorizeByRule {...this.props} />
						</TabPane>
						{showFlag && (
							<TabPane tab="按权限组授权" key="2">
								<AuthorizeByGroup
									allProjectList={allCommunities}
									labelGroupId={labelGroupId}
									allPrivileges={allPrivileges}
									{...this.props}
								/>
							</TabPane>
						)}
					</Tabs>
				)}
			</React.Fragment>
		);
	}
}

export default withRouter(RightManagement);
